import AddressInput from "js/components/common/AddressInput";
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import { inject, observer } from 'mobx-react';
import React from 'react';
import StepPage from './StepPage';

@inject('page')
@observer
export default class PickupDetails extends React.Component {

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : {
          mode: 'back',
          text: 'My items',
          url: url('my-items-page'),
        }
      : { mode: 'normal' };

  render() {
    const page = this.props.page;

    return (
      <StepPage current={1} page={page} backTo={'/create-link/size'}>
        <h5>Pick-up address</h5>

        <AddressInput
          name="address"
          showError={page.hasAddressError}
          address={page.address}
          onChange={page.addressSaved}
          placeholder="Enter your street address"
          flat={false}
          className="tw-w-full"
        />

        {page.address.address1 && (
          <div className="tw-flex tw-gap-4">
            <input type="checkbox" id="defaultAddress" placeholder="Save and set pickup address as default" />
            <label htmlFor="defaultAddress" className="p">Save and set pickup address as default</label>
          </div>
        )}

        <ContinueButton onClick={page.nextStep} disabled={!page.address.address1} >Continue</ContinueButton>
      </StepPage>
    );
  }
}
